import styled from 'styled-components';

export default styled.div`
    width: 100%;

    .MuiDataGrid-root {
        border: 0
    }

    .MuiDataGrid-main {
        border-radius: 20px;
    }

    .MuiDataGrid-columnHeader:first-of-type {
        border-top-left-radius: 19px !important;
    }

    .MuiDataGrid-columnHeader:last-of-type {
        border-top-right-radius: 19px !important;
    }

    .MuiChip-label {
        font-family: Poppins, serif;
        font-size: 12px;
        font-style: normal;

    }

    .MuiDataGrid-columnHeader {
        padding: 12px 24px 12px 24px !important;
        border-bottom: 1px solid var(--Structural-Structure-3, #C4C4C4);
    }

    .MuiDataGrid-columnHeaders div {
        background-color: ${(props) => props.theme.colorTableHeaderBackground} !important;
        color: ${(props) => props.theme.tertiaryFontColor} !important;
        font-weight: ${(props) => props.theme.fontWeightBolder} !important;
        font: font: ${(props) => props.theme.fontFamily};

    }

    .MuiDataGrid-row {
        background-color: ${(props) => props.theme.colorWhite} !important;
    }

    .MuiDataGrid-cell {
        padding: 0px 24px !important;
    }

    .MuiDataGrid-cell, .tableData {
        font-family: ${(props) => props.theme.fontFamily} !important;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        
        /* Prevent text from shrinking too much on mobile */
        @media (max-width: 640px) {
            font-size: 12px !important;
        }
    }

    .MuiDataGrid-cell:last-child {
        display: flex;
        align-items: center;
    }

    .MuiDataGrid-row [data-field="customer"] {
        display: flex;
        flex-wrap: wrap;
        align-content: center;
    }

    .MuiDataGrid-cell[data-colindex="5"] {
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
    }

    .MuiDataGrid-columnHeaderTitle {
        font-family: Poppins;
        font-size: 12px;
        font-weight: 700;
        
        /* Prevent header text from shrinking too much on mobile */
        @media (max-width: 640px) {
            font-size: 11px !important;
        }
    }

    .custInfo {
        font-size: 12px;
    }
`;
